import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { PdfViewerProvider } from "@/lib/PdfViewer";
import LoginPage from "@/pages/LoginPage";
import DashboardLayout from "@/pages/DashboardLayout";
import OrdersPage from "@/pages/OrdersPage";
import WarrantiesPage from "@/pages/WarrantiesPage";
import UsersPage from "@/pages/UsersPage";
import OverviewPage from "@/pages/OverviewPage";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

const Loading = () => (
    <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">
            <span className="inline-block w-2 h-2 bg-black mr-2 animate-pulse" />
            Yükleniyor
        </div>
    </div>
);

const Protected = ({ children, adminOnly = false }) => {
    const { user } = useAuth();
    if (user === null) return <Loading />;
    if (user === false) return <Navigate to="/login" replace />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
    return children;
};

const PublicOnly = ({ children }) => {
    const { user } = useAuth();
    if (user === null) return <Loading />;
    if (user) return <Navigate to="/dashboard" replace />;
    return children;
};

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <PdfViewerProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
                            <Route path="/" element={<Protected><DashboardLayout /></Protected>}>
                                <Route index element={<Navigate to="/dashboard" replace />} />
                                <Route path="dashboard" element={<OverviewPage />} />
                                <Route path="orders" element={<OrdersPage />} />
                                <Route path="warranties" element={<WarrantiesPage />} />
                                <Route path="users" element={<Protected adminOnly><UsersPage /></Protected>} />
                            </Route>
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </BrowserRouter>
                    <Toaster position="top-right" />
                </PdfViewerProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
